export const API_EXTERNAL_ENDPOINT = 'online-bookings/create'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/online-bookings/create'
